import { advertisementApi } from '../../api/advertisements';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'advertisements',
  api: advertisementApi,
  hasPublish: false,
  keyField: 'id',
});

export const advertisementReducer = slice.reducer;
export const advertisementActions = actions;

export const selectAdvertisements = (state) => state.advertisements.items;
export const selectAdvertisementsStatus = (state) => state.advertisements.status;